import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function ToDownThinArrow({ color = 'icon.primary', ...props }) {
  return (
    <IconBase viewBox="0 0 7 20" {...props}>
      <Path
        d="M3.33984 18.3242L1.00004 15.9844"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M5.54883 16.1094L3.33946 18.3187"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M3.34961 1L3.34961 18.3153"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  )
}

ToDownThinArrow.propTypes = {
  color: PropTypes.string,
}

export default ToDownThinArrow
